import { Component } from '@angular/core';

@Component({
  selector: 'allas-selecciona-la-bateria',
  imports: [],
  template: `<section class="flex flex-col xl:flex-row my-6 xl:my-12">
    <div
      class="p-6 xl:p-6 flex flex-col items-center xl:items-end justify-center gap-2 flex-auto xl:h-[500px] order-2 xl:order-1"
    >
      <h2
        class="text-2xl xl:text-4xl fs-condensed text-appBlack text-center xl:text-right"
      >
        SELECCIONA LA BATERÍA PARA TU VEHÍCULO
      </h2>
      <div class="flex gap-2">
        <a
          href="/repuestos/bateria-para-carro-auto-o-camioneta"
          class="text-xs xl:text-base bg-appBlack text-white px-4 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
        >
          COMPRAR AHORA
        </a>
        <a
          href="/servicios/entrega-domicilio"
          class="text-xs xl:text-base border-appBlack border text-appBlack px-4 py-2 rounded-md font-medium fs-condensed hover:scale-105 transition-all duration-300"
        >
          MÁS SERVICIOS
        </a>
      </div>
    </div>
    <div class="h-auto xl:h-[400px] order-1 xl:order-2">
      <img
        src="images/services/diagnostico-instalacion-baterias/escoje-tu-bateria.webp"
        alt="escoje-tu-bateria"
        class="h-full w-auto object-cover"
      />
    </div>
  </section>`,
})
export class SeleccionaLaBateria {}
